<template>
<div class="result-list">
    <div class="result"
         v-for="(item, index) in list"
         :key="`${index}-${item.id}`"
         @click="handleClickResult(index)">
        <div class="left">
          <img :src="`/image/map/${item.type}.png`" />
          <div class="name">{{ item.name }}</div>
        </div>
        <div class="distance">{{ item.distance }}</div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        list: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    methods: {
        handleClickResult (index) {
            this.$emit('result', index)
        }
    }
}
</script>

<style lang="scss" scoped>
.result {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: solid 1px #f7f7f7;

    img {
      width: 24px;
      height: 24px;
      display: block;
      flex-shrink: 0;
    }

    .left {
      display: flex;
      align-items: center;
      width: calc(100% - 80px);
    }

    .name {
      margin-left: 10px;
      font-size: 14px;
      line-height: 20px;
      color: #222125;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .distance {
      flex-shrink: 0;
      font-size: 12px;
      color: #222125;
    }
}
</style>